export function propertiesNav() {
	document.querySelectorAll('.section--properties-nav').forEach((section) => {
		section.querySelectorAll('.nav__bar a[href*="#"]').forEach((link) => {
			const id = link.hash.slice(1)

			if (id && link.pathname === location.pathname && !document.getElementById(id)) {
				link.closest('li')?.remove()
			}
		})

		if (!section.querySelector('.nav__bar li')) {
			section.remove()
			return
		}

		// The nav is sticky and may wrap onto two lines. Publish its height so
		// other sticky elements (.properties-ui-responsibility) can offset below it.
		const publishHeight = () =>
			document.documentElement.style.setProperty('--properties-nav-height', `${section.offsetHeight}px`)

		publishHeight()
		if ('ResizeObserver' in window) {
			new ResizeObserver(publishHeight).observe(section)
		} else {
			window.addEventListener('resize', publishHeight)
		}
	})
}
